import React, { useState } from 'react';
import __ from 'localisation';
import BackofficeProfileLink from '@hubins/components/BackofficeProfileLink';
import LoadingBar from '@hubins/components/LoadingIndicators';
import SimpleTable from 'modules/Tables/SimpleTable';
import EditProfileModal from '@hubins/components/EditProfileModal';
import Button, { ButtonWrap } from '@hubins/components/Button';
import ProfileHistory from '@hubins/components/ProfileHistory/ProfileHistory';
import { getLanguage } from 'helpers/language';
import countries from 'i18n-iso-countries';

const typeValueHeaders = [
  {
    Header: '',
    accessor: 'type',
  },
  {
    Header: '',
    accessor: 'value',
  }
]

const BackofficeProfileAttributes = ({profile, canEdit = false}) => {

  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [client, setClient] = useState(profile);

  const clientData = [
    {
      type: __('name'),
      value: (
        client?.name ? <BackofficeProfileLink profileUuid={client?.uuid}>
          {client?.name}
        </BackofficeProfileLink> : <LoadingBar />
      ),
    },
    {
      type: __('national_identity_number'),
      value: (
        client?.national_identity_number ? <BackofficeProfileLink profileUuid={client?.uuid}>
          {client?.national_identity_number}
        </BackofficeProfileLink> : <LoadingBar />
      ),
    },
    {
      type: __('email'),
      value: client?.email || '',
    },
    {
      type: __('email_status'),
      value: client?.email_verified_at ? <span className='c-success'>{__('verified')}</span> : <span className='c-danger'>{__('not_verified')}</span>,
    },
    {
      type: __('phone_number'),
      value: client?.phone_number || '',
    },
    {
      type: __('country'),
      value: client?.country ? countries.getName(client?.country, getLanguage()) : '',
    },
    {
      type: __('city'),
      value: client?.city || '',
    },
    {
      type: __('postal_code'),
      value: client?.postal_code || '',
    },
    {
      type: __('address'),
      value: client?.address || '',
    },
    ...(client?.type === 'COMPANY' ? [
      {
        type: "CRS",
        value: client?.crs ? __(`crs_${client?.crs}`) : '',
      },
      {
        type: "FATCA",
        value: client?.fatca ? __(`fatca_${client?.fatca}`) : '',
      }
    ] : []),
    {
      type: __('updated_at'),
      value: client?.updated_at || <LoadingBar />,
    },
  ];

  return (
    <>
    <SimpleTable headers={typeValueHeaders} data={clientData} />
      {
        canEdit && (
          <>
            <EditProfileModal
              profile={client}
              open={openProfileModal}
              setOpen={setOpenProfileModal}
              setProfile={setClient}
              isCompany={client?.type === 'COMPANY'}
            />
            <ButtonWrap>
              <Button icon="pencil write 2" onClick={() => setOpenProfileModal(true)}>
                {__('edit')}
              </Button>
              <ProfileHistory profileUuid={client?.uuid} />
            </ButtonWrap>
          </>
        )
      }
    </>
  );
};

export default BackofficeProfileAttributes;